'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var ReactDOM = _interopDefault(require('react-dom'));
var cx = _interopDefault(require('classnames'));
var reactPopper = require('react-popper');
var bodyScrollLock = require('body-scroll-lock');

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var PopoverStyle = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","defaultContentContainer":"arrive_Popover__defaultContentContainer"};

var createModifiers = function createModifiers(matchAnchorWidth, offset, screenSizeSmall, otherModifiers) {
  return [{
    name: 'offset',
    enabled: true,
    options: {
      offset: offset
    }
  }, // this is pulled from the docs https://popper.js.org/docs/v2/modifiers/community-modifiers/
  {
    name: 'sameWidth',
    enabled: matchAnchorWidth,
    phase: 'beforeWrite',
    requires: ["computeStyles"],
    fn: function fn(_ref) {
      var state = _ref.state;
      state.styles.popper.width = "".concat(Math.floor(state.rects.reference.width), "px");
    },
    effect: function effect(_ref2) {
      var state = _ref2.state;
      state.elements.popper.style.width = "".concat(state.elements.reference.offsetWidth, "px");
    }
  }].concat(_toConsumableArray(otherModifiers));
};

function useCallbackRef() {
  var ref = React.useRef(null);
  var setRef = React.useCallback(function (node) {
    if (node) {
      ref.current = node;
    }
  }, []);
  return [ref, setRef];
}

var Popover = React__default.forwardRef(function PopoverComponent(_ref3, popoverRef) {
  var _ref3$useBodyScrollLo = _ref3.useBodyScrollLock,
      useBodyScrollLock = _ref3$useBodyScrollLo === void 0 ? true : _ref3$useBodyScrollLo,
      _ref3$resolvedClasses = _ref3.resolvedClasses,
      resolvedClasses = _ref3$resolvedClasses === void 0 ? {} : _ref3$resolvedClasses,
      children = _ref3.children,
      popperContent = _ref3.popperContent,
      showPopover = _ref3.showPopover,
      setShowPopover = _ref3.setShowPopover,
      _ref3$externalClickLi = _ref3.externalClickListener,
      externalClickListener = _ref3$externalClickLi === void 0 ? function () {
    return setShowPopover(false);
  } : _ref3$externalClickLi,
      _ref3$placement = _ref3.placement,
      placement = _ref3$placement === void 0 ? 'auto' : _ref3$placement,
      _ref3$matchAnchorWidt = _ref3.matchAnchorWidth,
      matchAnchorWidth = _ref3$matchAnchorWidt === void 0 ? false : _ref3$matchAnchorWidt,
      _ref3$offset = _ref3.offset,
      offset = _ref3$offset === void 0 ? [0, 0] : _ref3$offset,
      _ref3$modifiers = _ref3.modifiers,
      modifiers = _ref3$modifiers === void 0 ? [] : _ref3$modifiers,
      arrow = _ref3.arrow,
      screenSizeSmall = _ref3.screenSizeSmall,
      scrollableChildRef = _ref3.scrollableChildRef;

  var _useCallbackRef = useCallbackRef(),
      _useCallbackRef2 = _slicedToArray(_useCallbackRef, 2),
      managerRef = _useCallbackRef2[0],
      setManagerRef = _useCallbackRef2[1];

  var popperRef = React.useRef(); // Do externalClicklistener OR dismiss if the user clicks outside the confines of component and it is active

  React.useEffect(function () {
    if (showPopover) {
      var popRef = popoverRef || popperRef;

      var onExternalClick = function onExternalClick(evt) {
        var isValidPopoverRef = popRef && popRef.current && !popRef.current.contains(evt.target);
        var isValidManagerRef = managerRef && !managerRef.current.contains(evt.target);

        if (isValidPopoverRef && isValidManagerRef) {
          externalClickListener(evt);
          evt.target.focus();
        }
      };

      var closeOnEscape = function closeOnEscape(evt) {
        if (evt.keyCode === 27) {
          externalClickListener(evt);
        }
      };

      document.addEventListener('click', onExternalClick);
      document.addEventListener("keydown", closeOnEscape);
      return function () {
        document.removeEventListener('click', onExternalClick);
        document.removeEventListener("keydown", closeOnEscape);
      };
    }
  }, [showPopover, setShowPopover, externalClickListener, popperRef, popoverRef, managerRef]);
  React.useEffect(function () {
    var hasLock = false;

    if (showPopover && useBodyScrollLock) {
      if (scrollableChildRef && scrollableChildRef.current) {
        hasLock = true;
        bodyScrollLock.disableBodyScroll(scrollableChildRef.current);
      } else if ((popoverRef || popperRef).current) {
        hasLock = true;
        bodyScrollLock.disableBodyScroll((popoverRef || popperRef).current);
      }
    } else {
      if (scrollableChildRef && scrollableChildRef.current) {
        bodyScrollLock.enableBodyScroll(scrollableChildRef.current);
        hasLock = false;
      } else if ((popoverRef || popperRef).current) {
        bodyScrollLock.enableBodyScroll((popoverRef || popperRef).current);
        hasLock = false;
      }
    }

    return function () {
      if (hasLock) {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    };
  }, [screenSizeSmall, showPopover, popperRef, popoverRef, scrollableChildRef, useBodyScrollLock]);
  return /*#__PURE__*/React__default.createElement(reactPopper.Manager, null, /*#__PURE__*/React__default.createElement(reactPopper.Reference, {
    innerRef: setManagerRef
  }, function (_ref4) {
    var ref = _ref4.ref;
    return /*#__PURE__*/React__default.createElement("div", {
      className: resolvedClasses && resolvedClasses.anchorClass,
      ref: ref,
      "data-testid": "anchor-container"
    }, children);
  }), showPopover && ReactDOM.createPortal(screenSizeSmall ? /*#__PURE__*/React__default.createElement("div", {
    className: cx(PopoverStyle.defaultContentContainer, resolvedClasses && resolvedClasses.contentContainerClass),
    ref: popoverRef || popperRef,
    style: {
      height: '100%',
      width: '100vw',
      position: 'fixed',
      top: 0,
      zIndex: 1
    },
    "aria-modal": "true"
  }, popperContent) : /*#__PURE__*/React__default.createElement(reactPopper.Popper, {
    innerRef: popoverRef || popperRef,
    placement: placement,
    modifiers: createModifiers(matchAnchorWidth, offset, screenSizeSmall, modifiers)
  }, function (_ref5) {
    var ref = _ref5.ref,
        style = _ref5.style,
        popperPlacement = _ref5.placement,
        arrowProps = _ref5.arrowProps;
    return /*#__PURE__*/React__default.createElement("div", {
      className: cx(PopoverStyle.defaultContentContainer, resolvedClasses && resolvedClasses.contentContainerClass),
      ref: ref,
      style: style,
      "data-placement": popperPlacement,
      "aria-modal": "true"
    }, popperContent, arrow && /*#__PURE__*/React__default.createElement("div", {
      "data-placement": popperPlacement,
      ref: arrowProps.ref,
      style: arrowProps.style,
      className: resolvedClasses.arrowClass
    }));
  }), document.getElementById('portalTarget')));
});
Popover.propTypes = {
  useBodyScrollLock: PropTypes.bool,
  resolvedClasses: PropTypes.shape({
    anchorClass: PropTypes.string,
    contentContainerClass: PropTypes.string,

    /**
     * This is used by @arrive/tooltip
     */
    arrowClass: PropTypes.string
  }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  popperContent: PropTypes.node.isRequired,
  showPopover: PropTypes.bool.isRequired,
  setShowPopover: PropTypes.func.isRequired,
  externalClickListener: PropTypes.func,
  placement: PropTypes.string,
  matchAnchorWidth: PropTypes.bool,
  offset: PropTypes.arrayOf(PropTypes.number),
  modifiers: PropTypes.arrayOf(PropTypes.object),
  scrollableChildRef: PropTypes.object,

  /**
   * This is used by @arrive/tooltip. If you want to use a tooltip use that package to include all the normal behaviors and styles
   */
  arrow: PropTypes.bool,
  screenSizeSmall: PropTypes.bool
};

module.exports = Popover;
